import React, { FC } from 'react';
import styles from './styles.module.css';
import { Modal } from 'antd';

type Props = {
  open: boolean;
  onCancel: () => void;
};

export const VideoModal: FC<Props> = ({ open, onCancel }) => {
  return (
    <Modal
      open={open}
      wrapClassName={`antd-container`}
      className={styles.modal}
      closable
      title={null}
      footer={null}
      centered
      destroyOnClose
      onCancel={onCancel}
    >
      <span className={styles.buttonVideoWrapper}>
        <iframe
          allow="autoplay; fullscreen; picture-in-picture"
          src="https://www.loom.com/embed/62d7f4d462c54a90b6d6bdcfd64cf40a?autoplay=1&hide_owner=true&hide_speed=true&hide_share=true&hide_title=true&hideEmbedTopBar=true"
          frameBorder="0"
          // @ts-expect-error
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
        />
      </span>
    </Modal>
  );
};
